import { Injectable } from '@angular/core';
import {BehaviorSubject, Observable} from "rxjs";
import {TimelineTimestamp} from "storyboard-renderer";

@Injectable()
export class TimeTrackingService {
  currentTime: Observable<TimelineTimestamp>;
  private _currentTime: BehaviorSubject<TimelineTimestamp>;

  constructor() {
    this._currentTime = <BehaviorSubject<TimelineTimestamp>>new BehaviorSubject(TimelineTimestamp.create());
    this.currentTime = this._currentTime.asObservable();
  }

  setCurrentTime(value: TimelineTimestamp) {
    this._currentTime.next(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/storyboard/shared/time-tracking.service.ts